// Wait for DOM to be fully loaded
document.addEventListener("DOMContentLoaded", function () {
  console.log("DOM Loaded - Script Started");

  // Check if button exists
  const testBtn = document.querySelector("#contactInGetOTP");
  console.log("Get OTP Button found:", testBtn);
  const hideSubmitBtn = document.querySelector("#contact-form-submit");
  hideSubmitBtn.style.display = "none";

  // Sign In Get OTP
  function signInGetOTPDetails(event) {
    console.log("signInGetOTPDetails function called!");
    if (event) event.preventDefault();
    
    const firstFormContact = document.querySelector("#firstFormContact").value.trim();
    
    // Validation
    if (!firstFormContact) {
      displayError("#contactFirstNumber", "Phone number is required");
      return;
    }
    
    if (!/^[6-9]\d{9}$/.test(firstFormContact)) {
      displayError("#contactFirstNumber", "Please enter a valid 10-digit phone number");
      return;
    }

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    
    const login = {
      mobileNumber: firstFormContact
    };
    
    // Make sure these functions exist in your global scope
    const Key = window.generateRandomString(32);
    const payload = window.Encrypt(login, Key);
    const sealValue = window.md5(`${payload}${Key}`);
    
    myHeaders.append("sealvalue", sealValue);
    myHeaders.append("key", Key);
    
    const raw = JSON.stringify({
      data: payload,
    });
    
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    // Show loading state
    const getOTPBtn = document.querySelector("#contactInGetOTP");
    getOTPBtn.innerText = "Sending...";
    getOTPBtn.disabled = true;

    fetch(`${window.Base_Url.Base_Url}/services/loginservice/rajnigandha/v2/contactus/sendotp`, requestOptions) 
      .then((response) => response.text())
      .then((data) => {
        const plainData = data.split("|")[0];
        const EncKey = data.split("|")[1].split("%%")[0];
        const result = window.Decrypt(plainData, EncKey);

        //console.log("contactOTP Response:", result);
        
        // Reset button
        getOTPBtn.innerText = "Get OTP";
        getOTPBtn.disabled = false;
        
        if (result.success == true) {
          // Hide Get OTP button, show OTP input and Verify button
          getOTPBtn.style.display = "none";
          document.querySelector("#contactPageOTPContainer").style.display = "block";
          document.querySelector("#contactInVerifyOTP").style.display = "inline-block";
          document.querySelector("#contactInMsgOTP").style.display = "block";

          // Disable Phone Number Input
          const firstFormContactInput = document.querySelector("#firstFormContact");
          firstFormContactInput.setAttribute("disabled", "true");

          startTimer("#contactInTimer", "#contactInResend", "#contactInResendTimer");
          
          // Clear error if any
          clearError("#contactFirstNumber");
          
        } else if (
          result.success == false &&
          result.message === "Please wait for this request to expire to request for another OTP."
        ) {
          displayError(
            "#contactFirstNumber",
            "Please wait for 3 min to expire current OTP"
          );
          getOTPBtn.style.display = "none";

          const expiresAt = result.expiresAt;
          if (expiresAt) {
            const expiryTime = convertToDate(expiresAt);
            const currentTime = new Date();

            if (currentTime < expiryTime) {
              const remainingTime = expiryTime - currentTime;
              startCountdown(
                remainingTime,
                "#remaingTimer",
                "#contactFirstNumber",
                "#contactInGetOTP"
              );
            }
          }
        } else {
          displayError("#contactFirstNumber", result.message || "Failed to send OTP");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        displayError("#contactFirstNumber", "Failed to send OTP. Please try again.");
        getOTPBtn.innerText = "Get OTP";
        getOTPBtn.disabled = false;
      });
  }

  // Sign In Verify OTP
  function signInVerifyOTPDetails(event) {
    if (event) event.preventDefault();
    
    const firstFormContact = document.querySelector("#firstFormContact").value.trim();
    const contactInOTP = document.querySelector("#contactInOTP").value.trim();

    // OTP Validation
    if (!contactInOTP) {
      displayError("#signInOTPError", "OTP is required");
      return;
    }
    
    if (!/^\d{6}$/.test(contactInOTP)) {
      displayError("#signInOTPError", "Please enter a valid 6-digit OTP");
      return;
    }

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const loginData = {
      mobileNumber: firstFormContact,
      otp: contactInOTP,
    };

    const Key = window.generateRandomString(32);
    const payload = window.Encrypt(loginData, Key);
    const sealValue = window.md5(`${payload}${Key}`);

    myHeaders.append("sealvalue", sealValue);
    myHeaders.append("key", Key);

    const raw = JSON.stringify({
      data: payload,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    const verifyBtn = document.getElementById("contactInVerifyOTP");
    verifyBtn.innerText = "Verifying...";
    verifyBtn.disabled = true;

    fetch(`${window.Base_Url.Base_Url}/services/loginservice/rajnigandha/v2/contactus/verifyotp`, requestOptions) 
      .then((response) => response.text())
      .then((data) => {
        const plainData = data.split("|")[0];
        const EncKey = data.split("|")[1].split("%%")[0];
        const result = window.Decrypt(plainData, EncKey);
        
        //console.log("Verify OTP Response:", result);
        
        verifyBtn.innerText = "Verify OTP";
        verifyBtn.disabled = false;

        if (result.success === true) {
          // Store verification status
          sessionStorage.setItem("otpVerified", "true");
          sessionStorage.setItem("verifiedPhone", firstFormContact);
          
          // Hide OTP section
          document.querySelector("#contactPageOTPContainer").style.display = "none";
          verifyBtn.style.display = "none";
          document.querySelector("#contactInTimer").style.display = "none";
          document.querySelector("#contactInResend").style.display = "none";
          
          // Show success message
          const successMsg = document.querySelector("#contactInMsgOTP");
          if (successMsg) {
            successMsg.innerHTML = '<p style="color: green;">✓ Phone number verified successfully!</p>';
          }
          
          // Re-enable phone input
          const firstFormContactInput = document.querySelector("#firstFormContact");
          firstFormContactInput.removeAttribute("disabled");
          
          clearError("#signInOTPError");
          
          console.log("OTP Verified Successfully");
          
          // ✨ NEW: Determine which form is active and call the callback
          const firstContactForm = document.querySelector('.first-contact-form');
          const secondContactForm = document.querySelector('.second-contact-form');
          
          if (firstContactForm && firstContactForm.style.display !== 'none') {
            // First form is active
            console.log("Calling handleOTPVerificationSuccess for first form");
            if (typeof window.handleOTPVerificationSuccess === 'function') {
              window.handleOTPVerificationSuccess('first');
            }
          } else if (secondContactForm && secondContactForm.style.display !== 'none') {
            // Second form is active
            console.log("Calling handleOTPVerificationSuccess for second form");
            if (typeof window.handleOTPVerificationSuccess === 'function') {
              window.handleOTPVerificationSuccess('second');
            }
          }
          
          // Show submit button (will be enabled by the callback if consent is checked)
          if (hideSubmitBtn) {
            hideSubmitBtn.style.display = "inline-block";
          }
          
        } else {
          displayError("#signInOTPError", result.message || "Invalid OTP");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        displayError("#signInOTPError", "Failed to verify OTP. Please try again.");
        verifyBtn.innerText = "Verify OTP";
        verifyBtn.disabled = false;
      });
  }

  // Event Listener for Get OTP Button
  const contactInGetOTPBtn = document.querySelector("#contactInGetOTP");
  //console.log("Attaching event to Get OTP button:", contactInGetOTPBtn);
  
  if (contactInGetOTPBtn) {
    contactInGetOTPBtn.addEventListener("click", function(e) {
      console.log("Get OTP button clicked!");
      e.preventDefault();
      signInGetOTPDetails(e);
    });
  } else {
    console.error("ERROR: Get OTP button not found!");
  }

  // Event Listener for Verify OTP Button
  const contactInVerifyOTPBtn = document.querySelector("#contactInVerifyOTP");
  contactInVerifyOTPBtn?.addEventListener("click", function (e) {
    e.preventDefault();
    signInVerifyOTPDetails();
  });

  // Sign In Resend OTP
  const contactInResend = document.querySelector("#contactInResend a");
  if (contactInResend) {
    contactInResend.addEventListener("click", function (e) {
      e.preventDefault();
      // Clear OTP input when resending
      const otpInput = document.querySelector("#contactInOTP");
      if (otpInput) {
        otpInput.value = "";
      }
      clearError("#signInOTPError");
      signInGetOTPDetails();
    });
  }

  // Timer Function
  function startTimer(timerOTP, resendOTP, timerRunning) {
    const timerOTPElement = document.querySelector(timerOTP);
    const resendOTPElement = document.querySelector(resendOTP);
    const timerRunningElement = document.querySelector(timerRunning);
    
    if (!timerOTPElement || !resendOTPElement || !timerRunningElement) return;
    
    let timeLeft = 300; // 5 minutes

    resendOTPElement.style.display = "none";
    timerOTPElement.style.display = "block";

    const formatTime = (totalSeconds) => {
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
    };

    timerRunningElement.innerText = `Resend OTP in ${formatTime(timeLeft)}`;
    const intervalTime = setInterval(() => {
      timeLeft -= 1;
      if (timeLeft <= 0) {
        clearInterval(intervalTime);
        timerOTPElement.style.display = "none";
        resendOTPElement.style.display = "block";
      } else {
        timerRunningElement.innerText = `Resend OTP in ${formatTime(timeLeft)}`;
      }
    }, 1000);
  }

  // Expired Date Format
  function convertToDate(timeStr) {
    const currentDate = new Date();
    const timeParts = timeStr.split(" ");
    const [hours, minutes, seconds] = timeParts[0].split(":");
    const amPm = timeParts[1].toLowerCase();

    let hour = parseInt(hours, 10);
    if (amPm === "pm" && hour < 12) {
      hour += 12;
    } else if (amPm === "am" && hour === 12) {
      hour = 0;
    }

    return new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate(),
      hour, 
      parseInt(minutes), 
      parseInt(seconds), 
      0
    );
  }

  // Expired Timer
  function startCountdown(duration, timerSelector, errorSelector, getOtpButtonSelector) {
    let timer = duration;
    const timerElement = document.querySelector(timerSelector);
    
    if (timerElement) {
      timerElement.style.display = "block";
    }
    
    const interval = setInterval(() => {
      const minutes = Math.floor(timer / 60000);
      const seconds = Math.floor((timer % 60000) / 1000);

      if (timerElement) {
        timerElement.textContent = `Remaining Time: ${minutes}m ${seconds}s`;
      }
      
      timer -= 1000;
      
      if (timer <= 0) {
        clearInterval(interval);
        if (timerElement) timerElement.style.display = "none";
        clearError(errorSelector);
        const getOtpBtn = document.querySelector(getOtpButtonSelector);
        if (getOtpBtn) getOtpBtn.style.display = "inline-block";
      }
    }, 1000);
  }

  // Helper Functions
  function displayError(selector, message) {
    const errorElement = document.querySelector(selector);
    if (errorElement) {
      errorElement.textContent = message;
      errorElement.style.display = "block";
      errorElement.style.color = "red";
    }
  }

  function clearError(selector) {
    const errorElement = document.querySelector(selector);
    if (errorElement) {
      errorElement.textContent = "";
      errorElement.style.display = "none";
    }
  }
});